module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/4-8a3b21978ca7a3cfae27205b7d82d8c4.jpeg";